import React from 'react'

import ReactPlayer from 'react-player'
import { useDispatch } from 'react-redux'

import { setVideoPlaying } from '@/redux/ui/uiSlice'

interface IncidentNoteVideoPlayerIProps {
  height?: string | number
  play?: boolean
  videoUrl: string
  width?: string | number
}

export const IncidentNoteVideoPlayer = ({
  height = '100%',
  play = false,
  videoUrl,
  width = '100%',
}: IncidentNoteVideoPlayerIProps) => {
  const dispatch = useDispatch()

  const handlePlay = () => {
    dispatch(setVideoPlaying(true))
  }

  const handlePause = () => {
    dispatch(setVideoPlaying(false))
  }

  return (
    <ReactPlayer
      controls
      data-testid='incident-note-video-player'
      height={height}
      loop
      muted
      onPause={handlePause}
      onPlay={handlePlay}
      playing={play}
      url={videoUrl}
      width={width}
    />
  )
}
